import React from "react";

export const card = {
  padding: 12, background: "var(--pf-surface)",
  border: "1px solid var(--pf-border)", borderRadius: 8,
  display: "flex", flexDirection: "column",
};

export const label = {
  fontSize: 11, fontWeight: 700, color: "var(--pf-muted)",
  textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 6,
};

export const input = {
  width: "100%", padding: "6px 8px", fontSize: 12, borderRadius: 5,
  border: "1px solid var(--pf-border)", background: "var(--pf-surface-2)",
  color: "var(--pf-fg)", boxSizing: "border-box",
};

export const btn = {
  padding: "8px 12px", fontSize: 12, fontWeight: 700,
  background: "var(--pf-ember)", color: "#fff", border: 0,
  borderRadius: 5, cursor: "pointer",
};

export const btnGhost = {
  padding: "6px 10px", fontSize: 11, fontWeight: 600,
  background: "transparent", color: "var(--pf-fg)",
  border: "1px solid var(--pf-border)", borderRadius: 5, cursor: "pointer",
};

export function downloadBlob(blobUrl, filename) {
  const a = document.createElement("a");
  a.href = blobUrl; a.download = filename;
  document.body.appendChild(a); a.click();
  setTimeout(() => document.body.removeChild(a), 100);
}

export function SvgViewer({ blobUrl, testId, emptyText }) {
  return (
    <div data-testid={testId} style={{
      ...card,
      minHeight: 600,
      padding: 0,
      overflow: "hidden",
    }}>
      {blobUrl ? (
        <iframe title="drawing"
          src={blobUrl}
          style={{ width: "100%", height: 720, border: 0, background: "#0d0f12" }} />
      ) : (
        <div style={{
          flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
          color: "var(--pf-muted)", fontSize: 12, padding: 24, textAlign: "center",
        }}>{emptyText || "No drawing yet."}</div>
      )}
    </div>
  );
}
